import { ApiError } from '../api/client';
import { useWebmailToken } from '../api/queries/mailbox';

export function WebmailPage(): JSX.Element {
  const { data, isPending, isError, error } = useWebmailToken();

  if (isPending) {
    return (
      <div className="page">
        <p className="muted">Loading webmail…</p>
      </div>
    );
  }

  if (isError || !data) {
    let msg = 'Could not load webmail. Try again later.';
    if (error instanceof ApiError) {
      if (error.status === 409) msg = "You don't have an active company mailbox yet.";
      else if (error.status === 404) msg = "Your account isn't linked to a person record.";
      else if (error.status === 500) msg = 'Webmail is not configured on this server.';
    }
    return (
      <div className="page">
        <header className="page-header">
          <h1>My Webmail</h1>
        </header>
        <p className="muted" role="alert">{msg}</p>
      </div>
    );
  }

  return (
    <iframe
      src={data.url}
      title="Company Webmail"
      allow="unload"
      style={{
        position: 'fixed',
        // AppShell topbar height: 56px (hardcoded in app.css .app-topbar)
        top: '56px',
        // AppShell sidebar width: var(--sidebar-w) = 232px
        left: 'var(--sidebar-w)',
        right: 0,
        bottom: 0,
        width: 'calc(100vw - var(--sidebar-w))',
        height: 'calc(100vh - 56px)',
        border: 'none',
        display: 'block',
      }}
    />
  );
}
